export const contentfulImageLoader = ({
  src,
  format = 'webp',
  width,
  quality = 80,
}: {
  src: string;
  width: number;
  quality?: number;
  format?: string;
}) => {
  const isSvg = src.match('.svg');
  return `https:${src}?${isSvg ? '' : `fm=${format}`}&w=${width}&q=${quality}`;
};
